import "./Contact.module.css";
import MainHeader from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import DoveTrovarci from "./sections/DoveTrovarci";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainHeader />
      <StartYourJourney />
      <DoveTrovarci />
      <Footer />
    </div>;
}